export enum MobileAppPromoType {
    attaches = 'attaches',
    lm = 'lm',
}
